import React from 'react';

export const AVATAR_COLOR: Record<string, string> = {
  Jawwad: '#6366F1',
  Antoine: '#8B5CF6',
  Aayan: '#06B6D4',
};

export const DEFAULT_AVATAR_COLOR = '#94A3B8';

export function avatarColorFor(name?: string | null): string {
  if (!name) return DEFAULT_AVATAR_COLOR;
  return AVATAR_COLOR[name] ?? DEFAULT_AVATAR_COLOR;
}

export function initialFor(name?: string | null): string {
  return (name?.trim()[0] ?? '?').toUpperCase();
}

interface AvatarProps {
  name?: string | null;
  size?: number;
  title?: string;
  style?: React.CSSProperties;
}

export default function Avatar({ name, size = 28, title, style }: AvatarProps) {
  return (
    <div
      title={title ?? name ?? 'Unassigned'}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        background: avatarColorFor(name),
        color: 'white',
        fontSize: `${Math.round(size * 0.43)}px`,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...style,
      }}
    >
      {initialFor(name)}
    </div>
  );
}
